import { IDocument, IInput } from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

export interface PasswordControlWithValue {
  readonly control: IInput;
  readonly type: 'password';
  value: string;
}

/**
 * Check that input control meta is password meta
 *
 * @param control - control metadata
 */
export function isPasswordControl(control: IInput): boolean {
  return control.$type === 'password';
}

/**
 * Map control metadata to typed object with value from doc state
 *
 * @param control - control metadata
 * @param doc - doc
 */
export function getTypeControlForPassword(
  control: IInput,
  doc: IDocument,
): PasswordControlWithValue {
  return {
    value: DocHelper.getStringValue(control.$name, doc),
    control,
    type: 'password',
  };
}
